import { createTheme } from "@mui/material/styles";
import { colors } from "./colors";

const theme = createTheme({
    palette: {
        primary: {
            main: colors.azul,
            contrastText: colors.branco,
        },
        secondary: {
            main: colors.cinza,
        },
        background: {
            default: colors.backgroundPage,
            paper: colors.branco,
        },
        text: {
            primary: colors.cinza,
            secondary: colors.branco,
        },
    },

    typography: {
        fontFamily: "'Inter', sans-serif",
        button: {
            textTransform: "none",
            fontWeight: 600,
        }
    },

    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: colors.azul,
                    boxShadow: "none",
                },
            },
        },
    },
});

export default theme;
